// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Addon } from './addon';
import { ManufacturerProductTypeConfig } from './manufacturer-product-type-config';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerProductTypeConfigAddon extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(255) */
  additionalInfo?: string;
  /** Int32 FK addon */
  addonId!: number;
  /** Int32 FK manufacturerProductTypeConfig */
  manufacturerProductTypeConfigId!: number;
  /** FK addonId */
  addon!: Addon;
  /** FK manufacturerProductTypeConfigId */
  manufacturerProductTypeConfig!: ManufacturerProductTypeConfig;
}

